/**
 *
 * @param {boolean} emailOtp
 */
export const getSendOtpUrl = (emailOtp) => {
  if (emailOtp) {
    return "/email-otp";
  }
  return "/mobile-number";
};
